module.exports = __webpack_public_path__ + "img/SC1-hero.4cf9d9fb.png";